import { AuditAction } from '@sr/dto';

type AuditActionColor = {
  background: string;
  border: string;
  text: string;
};

const DEFAULT_COLOR: AuditActionColor = {
  background: '#F5F7FA',
  border: '#CFD8DC',
  text: '#37474F',
};

const ACTION_COLORS: Partial<Record<AuditAction, AuditActionColor>> = {
  [AuditAction.COMPANY_CREATED]: { background: '#E3F2FD', border: '#90CAF9', text: '#0D47A1' },
  [AuditAction.COMPANY_RENAMED]: { background: '#E8EAF6', border: '#9FA8DA', text: '#283593' },
  [AuditAction.COMPANY_MANAGER_LINKED]: { background: '#E0F7FA', border: '#4DD0E1', text: '#006064' },
  [AuditAction.COMPANY_MANAGER_UNLINKED]: { background: '#FCE4EC', border: '#F48FB1', text: '#880E4F' },
  [AuditAction.COMPANY_LEAD_LINKED]: { background: '#E8F5E9', border: '#A5D6A7', text: '#1B5E20' },

  [AuditAction.CONTRACT_UPDATED]: { background: '#E8F5E9', border: '#A5D6A7', text: '#1B5E20' },
  [AuditAction.LEGAL_ENTITY_UPDATED]: { background: '#FFF8E1', border: '#FFE082', text: '#FF6F00' },

  [AuditAction.MEDIA_CREATED]: { background: '#FFF3E0', border: '#FFB74D', text: '#E65100' },
  [AuditAction.MEDIA_UPDATED]: { background: '#FFFDE7', border: '#FFF176', text: '#F57F17' },

  [AuditAction.PAYORDER_CREATED]: { background: '#E8F5E9', border: '#A5D6A7', text: '#1B5E20' },
  [AuditAction.PAYORDER_UPDATED]: { background: '#E0F2F1', border: '#80CBC4', text: '#004D40' },
  [AuditAction.PAYORDER_STATUS_CHANGED]: { background: '#FFF3E0', border: '#FFCC80', text: '#E65100' },

  [AuditAction.PURCHASE_CREATED]: { background: '#F3E5F5', border: '#CE93D8', text: '#4A148C' },
  [AuditAction.PURCHASE_STATUS_CHANGED]: { background: '#EDE7F6', border: '#B39DDB', text: '#4527A0' },
  [AuditAction.PURCHASE_WCC_AUTOMATION_FAILED]: { background: '#FFF3E0', border: '#FFCC80', text: '#E65100' },

  [AuditAction.LEAD_CREATED]: { background: '#F1F8E9', border: '#C5E1A5', text: '#33691E' },
  [AuditAction.LEAD_STATUS_CHANGED]: { background: '#FFFDE7', border: '#FFE082', text: '#F57F17' },
  [AuditAction.LEAD_COMPANY_LINKED]: { background: '#E0F2F1', border: '#80CBC4', text: '#004D40' },

  [AuditAction.INVOICE_CREATED]: { background: '#E0F2F1', border: '#4DB6AC', text: '#004D40' },
  [AuditAction.INVOICE_UPDATED]: { background: '#E8EAF6', border: '#9FA8DA', text: '#283593' },

  [AuditAction.USER_UPDATED]: { background: '#E3F2FD', border: '#90CAF9', text: '#0D47A1' },
};

export const getAuditActionColors = (action: AuditAction): AuditActionColor => {
  return ACTION_COLORS[action] ?? DEFAULT_COLOR;
};
